<template>
  <div class="gts" :style="{ transform: `rotate(${getPlayerDistanceInDeg()}deg)` }">
    <div
      class="gts__inner"
      :style="{
        transform: `translate(-50%, -50%) rotate(-${getPlayerDistanceInDeg()}deg)`,
      }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      totalPlayers: {
        type: Number,
        required: true,
      },
      number: {
        type: Number,
        required: true,
      },
    },
    data: () => ({
      playerDistanceInDeg: 0,
    }),
    watch: {
      totalPlayers() {
        this.calculatePlayerDistanceInDeg();
      },
    },
    created() {
      this.calculatePlayerDistanceInDeg();
    },
    methods: {
      calculatePlayerDistanceInDeg() {
        this.playerDistanceInDeg = 360 / (this.totalPlayers || 1);
      },
      getPlayerDistanceInDeg() {
        return this.playerDistanceInDeg * this.number + 180;
      },
    },
  };
</script>

<style scoped lang="scss">
  .gts {
    position: absolute;
    top: 0;
    left: 0;
    //
    width: 100%;
    height: 100%;
    transition: all 200ms;

    &__inner {
      pointer-events: all;
      display: inline-block;
      //
      position: absolute;
      left: 50%;
      top: 0;
      transform: translate(-50%, -50%);
      transition: all 200ms;
    }
  }
</style>
